import { render, staticRenderFns } from "./AuditTab.vue?vue&type=template&id=f55cf60a&scoped=true"
import script from "./AuditTab.vue?vue&type=script&lang=js"
export * from "./AuditTab.vue?vue&type=script&lang=js"
import style0 from "./AuditTab.vue?vue&type=style&index=0&id=f55cf60a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f55cf60a",
  null
  
)

export default component.exports